import React from "react";
import { OliveLogo } from "./OliveLogo";
import { useLang } from "../lib/i18n";
import Newsletter from "./Newsletter";
import { LegalLinks } from "./Legal";
import { BUSINESS_INFO } from "../lib/business";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="footer"
      className="relative py-16 px-6 border-t border-[color:var(--goldenelia-gold)]/25"
    >
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center gap-3">
        <OliveLogo size={64} />
        <p className="font-display gold-gradient-text text-2xl tracking-[0.22em]">GOLDEN ELIA</p>
        <p className="font-display text-[10px] tracking-[0.4em] text-[color:var(--goldenelia-gold)]/85 uppercase">
          Greek Treasure
        </p>
        <p className="font-serif-luxury italic text-[color:var(--goldenelia-gold-bright)] text-sm">
          The Pure Essence of Greece
        </p>
        <div className="gold-divider max-w-xs w-full mt-3">
          <span className="diamond" />
        </div>

        <div className="w-full mt-8 mb-6">
          <Newsletter />
        </div>

        <div className="mt-6 mb-2">
          <LegalLinks />
        </div>

        <p className="font-display text-[10px] tracking-[0.3em] uppercase mt-3">
          <a
            href="/track"
            data-testid="footer-track-link"
            className="text-[color:var(--goldenelia-gold)]/85 hover:text-[color:var(--goldenelia-gold-bright)]"
          >
            Παρακολούθηση Παραγγελίας →
          </a>
        </p>

        <p className="font-body text-xs text-[color:var(--goldenelia-cream)]/55 mt-3 max-w-2xl">
          © {new Date().getFullYear()} <strong className="text-[color:var(--goldenelia-gold)]/80">Golden Elia</strong> — Greek Treasure. {t("footer")}
        </p>
        <p className="font-body text-[10px] text-[color:var(--goldenelia-cream)]/40">
          {BUSINESS_INFO.legal_name} · ΑΦΜ {BUSINESS_INFO.afm} · ΓΕΜΗ {BUSINESS_INFO.gemi}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
